import { loadWithConsent } from 'core/utils/consent-vendor'

export default {
  acceptAll({ commit }) {
    commit('setConsentStatus', 'accepted')
    commit('setPreferences', {
      necessary: true,
      analytics: true,
      advertising: true,
      functional: true
    })
    commit('setLastUpdated', new Date().toISOString())
    this.dispatch('cookies/saveToStorage')
    try {
      loadWithConsent.loadAll()
    } catch (error) {
      throw error
    }
  },

  rejectAll({ commit }) {
    commit('setConsentStatus', 'rejected')
    commit('setPreferences', {
      necessary: true,
      analytics: false,
      advertising: false,
      functional: false
    })
    commit('setLastUpdated', new Date().toISOString())
    this.dispatch('cookies/saveToStorage')
    try {
      loadWithConsent.loadAll()
    } catch (error) {
      throw error
    }
  },

  saveCustomPreferences({ commit }, preferences) {
    commit('setConsentStatus', 'custom')
    commit('setPreferences', preferences)
    commit('setLastUpdated', new Date().toISOString())
    this.dispatch('cookies/saveToStorage')
    try {
      loadWithConsent.loadAll()
    } catch (error) {
      throw error
    }
  },

  hideBanner({ commit }) {
    commit('setBannerVisible', false)
  },

  saveToStorage({ state }) {
    const cookieData = {
      preferences: state.preferences,
      consentStatus: state.consentStatus,
      bannerVisible: state.bannerVisible,
      lastUpdated: state.lastUpdated
    }
    localStorage.setItem('cookies', JSON.stringify(cookieData))
  },

  loadFromStorage({ commit }) {
    const storedData = localStorage.getItem('cookies')
    if (storedData) {
      try {
        const parsedData = JSON.parse(storedData)

        if (parsedData && parsedData.preferences && parsedData.consentStatus) {
          commit('setPreferences', parsedData.preferences)
          commit('setConsentStatus', parsedData.consentStatus)

          if (parsedData.lastUpdated) {
            commit('setLastUpdated', parsedData.lastUpdated)
          }

          if (parsedData.bannerVisible !== undefined) {
            commit('setBannerVisible', parsedData.bannerVisible)
          }
        } else {
          commit('resetPreferences')
        }
      } catch (error) {
        console.error('Failed to parse cookie preferences from storage:', error)
        commit('resetPreferences')
      }
    }
  },

  resetPreferences({ commit }) {
    commit('resetPreferences')
    localStorage.removeItem('cookies')
  }
}
